import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ProductVariant } from 'src/app/classes/utility';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  public variantSubject = new ReplaySubject<ProductVariant>(1);
  public variantObservable = this.variantSubject.asObservable();

  public sleeveSubject = new ReplaySubject<ProductVariant | undefined>(1);
  public sleeveObservable = this.sleeveSubject.asObservable();

  constructor() {}

  calculategroups(product: any, lines: any) {
    lines = lines.filter((x: any) => x.hidden !== true);
    let relations: any[] = [];
    let group1;
    let group2;
    let group3;
    for (let entry of lines) {
      group1 = this.findGroupName(entry, 'group-1-');
      if (group1) {
        this.upsertFacet(group1, lines, relations);
      }
      group2 = this.findGroupName(entry, 'group-2-');
      if (group2) {
        this.upsertFacet(group2, lines, relations);
      }
      group3 = this.findGroupName(entry, 'group-3-');
      if (group3) {
        this.upsertFacet(group3, lines, relations);
      }
    }
    if (group1) {
      this.calculateActiveFacetValue(product, relations[0], lines);
    }
    if (group2) {
      this.calculateActiveFacetValue(product, relations[1], lines);
    }
    if (group3) {
      this.calculateActiveFacetValue(product, relations[2], lines);
    }
    this.calculatePreviews(relations, lines);
    return relations;
  }

  calculatePreviews(relations: any, lines: any) {
    for (let relation of relations) {
      for (let option of relation.entries) {
        option.options = this.calculateOptionsAvailability(
          relations,
          lines,
          relation,
          option.label
        );
        option.options.sort((a: any, b: any) => a.label.localeCompare(b.label));
      }
    }
  }

  calculateOptions(relations: any, lines: any) {
    if (!relations || !lines) return;
    let localrelations = structuredClone(relations);
    const testingObj = localrelations.map((x: any) => ({
      key: x.key,
      value: x.value,
    }));
    return lines
      .filter((x: any) => x.hidden !== true)
      .filter((product: any) =>
        testingObj.every(
          (relation: any) => product[relation.key] === relation.value
        )
      );
  }

  calculateOptionsAvailability(
    relations: any,
    lines: any,
    relation: any,
    option: any
  ) {
    let localrelations = structuredClone(relations);
    const testingObj = localrelations.map((x: any) => ({
      key: x.key,
      value: x.value,
    }));

    let testEntry = testingObj.find((x: any) => x.key == relation.key);
    testEntry.value = option;

    return lines.filter((product: any) =>
      testingObj.every(
        (relation: any) => product[relation.key] === relation.value
      )
    );
  }

  calculateVariant(products: any, group: any, value: any, variant: any) {
    const groups = {
      group1: group.position == 1 ? value : variant?.group1 ?? '',
      group2: group.position == 2 ? value : variant?.group2 ?? '',
      group3: group.position == 3 ? value : variant?.group3 ?? '',
    };
    const selectedVariant = products.find((x: any) => {
      return (
        x.group1 == groups.group1 &&
        x.group2 == groups.group2 &&
        x.group3 == groups.group3
      );
    });
    return selectedVariant;
  }

  findGroupName(product: any, discoverKey: string) {
    if (!discoverKey.startsWith('group-')) return undefined;
    const groupName = Object.keys(product).find((key) =>
      key.startsWith(discoverKey)
    );
    if (!groupName) return undefined;
    let values = groupName.split('-');

    return {
      group: values[2],
      position: parseInt(values[1]),
      entry: product[groupName],
      property: groupName,
    };
  }

  selectOption(relations: any, relation: any, option: any, lines: any) {
    relation._active = false;
    relation.value = option;

    const testingObj = relations.map((x: any) => ({
      key: x.key,
      value: x.value,
    }));

    const outcome = lines.filter((product: any) =>
      testingObj.every(
        (relation: any) => product[relation.key] === relation.value
      )
    );
    return outcome;
  }

  calculateActiveFacetValue(product: any, facet: any, _lines: any) {
    facet.value = _lines.find((x: any) => x.id == '' + product.id)[facet.key];
  }

  upsertFacet(
    value: {
      group: string;
      position: number;
      entry: string;
      property: any;
    },

    _lines: any,
    _relations: any
  ) {
    let existing = _relations?.find((x: any) => x.position === value.position);
    if (!existing) {
      existing = {
        group: value.group,
        key: value.property,
        position: value.position,
        entries: [{ label: value.entry }],
      };
      _relations.push(existing);
    } else {
      const existingValue = existing.entries.find(
        (x: any) =>
          x.label.toLocaleLowerCase() == value.entry.toLocaleLowerCase()
      );
      if (!existingValue) {
        existing.entries.push({ label: value.entry });
      }
    }
  }
}
